export default __webpack_public_path__ + "static/media/pros-cons-sourcing-from-food-manufacturers.7e6b47c3.svg";